import { Box } from "@mui/material";
import DefaultText from "../../../../../../../components/typography/default-text";
import styles from "./styles.module.css";

import { ReactNode } from "react";

const GridTextCard: React.FC<{
  image?: string;
  title?: string | ReactNode;
  description?: string | ReactNode;
  titleFontSize?: string;
}> = ({ image, title, description, titleFontSize = "32px" }) => {
  return (
    <div className={styles["our-numbers-grid-card"]}>
      <div
        style={{
          height: "120px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
          backgroundColor: "var(--secondary-grey)",
        }}
      >
        <img src={image} alt="Imagem de conteúdo" />
      </div>
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        textAlign={"center"}
      >
        <DefaultText size="small" style={{ whiteSpace: "pre-line" }}>
          <span
            style={{
              fontFamily: "Montserrat-SemiBold",
              fontSize: titleFontSize,
              fontWeight: 700,
            }}
          >
            {title}
          </span>
        </DefaultText>
        <DefaultText size={"xs"} style={{ whiteSpace: "pre-line" }}>
          <span
            style={{
              fontFamily: "Montserrat-Regular",
              fontSize: "20px",
              fontWeight: 600,
              fontStyle: "italic",
            }}
          >
            {description}
          </span>
        </DefaultText>
      </Box>
    </div>
  );
};

export default GridTextCard;
